import React, { useContext, useEffect, useState } from 'react'
import downarrow from './assets/downarrow.png';
import GemIcon from "../assets/diamondImg.png";

import claimed from './assets/claimed.png'
import paid from './assets/paid.png'
import cancelled from './assets/cancelled.png'
import pending from './assets/pending.png'
import failed from './assets/error.png'
import rejectIcon from '../assets/rejectIcon.png'
import partialCancelIcon from '../assets/partialCancel.svg'
import greenArrow from '../assets/greenArrow.png'
import redArrow from '../assets/redArrow.png'
import InvoiceIcon from "../assets/invoice.svg"
import { WebToNativeMessage } from '../Common/Utils';//WebToNativeMessage({ type: "closeClient" })
import { RUPEE_SYMBOL } from '../Strings'
import SmartToWalletSuccess from '../assets/SmartToWalletSuccess.svg';
import SmartToBankSuccess from '../assets/SmartToBankSuccess.svg'
import { UserContext } from '../OEMChanges/OemAssetsImport'

const TransactionItem = ({ data, expand, index, setExpandedIndex,setShowTDSIframe }) => {
    let middleSectionHTML = null
const isOem = sessionStorage.getItem("channel").toLocaleLowerCase() === "oemaps1";
    useEffect(() => {
            if (sessionStorage.getItem("channel") === "OEMAPS1") {
            //   import('./TransactionSummaryOEM.css');
            import('./TransactionSummaryOEM.css');
            } else {
              import('./TransactionSummary.css');
            }
          }, [])
    const assets = useContext(UserContext);
    const dateFormatter = (date) => {
        let day = new Date(date).getDate()
        const nth = function (d) {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        }
        let suffix = nth(day)
        let newDay = day + suffix
        let month = new Date(date).toLocaleString('default', { month: 'short' })
        let year = new Date(date).toLocaleString('default', { year: '2-digit' })
        let dateString = `${newDay} ${month}'${year}`
        return dateString
    }

    const timeFormatter = (date) => {
        let time = new Date(date).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
        return time
    }

    const middleSectionDisplay = (data) => {
        // let middleSectionHTML = null;
        console.log("data type", data);
        switch (data.event) {
            case 'Bonus':
                if (data.eventType === 'bonus-extraCash-instant') {
                    middleSectionHTML = (data?.bonusCode===null || data?.bonusCode===undefined || data?.bonusCode==='') ? null : (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>Bonus Code: </span>
                                <span className='ts-bold-value'>{data.bonusCode}</span>
                            </div>
                            <div className='ts-id'>
                                <span>Purchase ID: </span>
                                <span className='ts-id-value'>{data.transactionID}</span>
                            </div>
                        </div>
                    )
                } else if (data.eventType === 'rne-referrer-bonus') {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>Bonus Code: </span>
                                <span className='ts-bold-value'>{data.bonusCode}</span>
                            </div>
                            <div className='ts-id'>
                                <span>Transaction ID: </span>
                                <span className='ts-id-value'>{data.transactionID}</span>
                            </div>
                        </div>
                    )
                } else if (data.eventType === 'bonus-HappyHours') {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>Bonus Type: </span>
                                <span className='ts-bold-value'>{data.bonusType}</span>
                            </div>
                            <div className='ts-id'>
                                <span>Bonus Code: </span>
                                <span className='ts-id-value'>{data.bonusCode}</span>
                            </div>
                        </div>
                    )
                } else if (data.eventType === 'bonus-achievements') {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>Achievement Name: </span>
                                <span className='ts-bold-value'>{data.name}</span>
                            </div>
                        </div>
                    )
                } else if (data.eventType === 'Surplus-Bonus-Reversal') {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>Bonus Code: </span>
                                <span className='ts-bold-value'>{data.bonusCode}</span>
                            </div>
                            <div className='ts-id'>
                                <span>Game ID: </span>
                                <span className='ts-id-value'>{data.transactionID}</span>
                            </div>
                        </div>
                    )
                } else if (data.eventType === 'GV-added') {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>GV Code: </span>
                                <span className='ts-bold-value'>{data.bonusCode}</span>
                            </div>
                        </div>
                    )
                } else if (data.eventType === 'bonus-released' || data.eventType === 'bonus-extraCash-wagered') {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>Bonus Code: </span>
                                <span className='ts-bold-value'>{data.bonusCode}</span>
                            </div>

                            
                        </div>
                    )
                }

                else if (data.eventType === 'gst_addCash_bonus') {
                    middleSectionHTML = (
                        <div className={'ts-more-info-row'}>
                            <div className='ts-payment-mode'>
                                <span>Txn ID: </span>
                                <span className='ts-bold-value'>{data.transactionID}</span>
                            </div>
                        </div>
                    )
                }
                break
            case 'Refund':
                // alert();
                if (data.eventType === 'tourney-refund' ) {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>Tourney ID: </span>
                                {/* <span className='ts-bold-value'>{data.gameType === 'poker' ? data.tableId : data.joinedPoolID}</span> */}
                                <span className='ts-bold-value'>{data.gameType === 'poker' ? data.pokerObj!==undefined ? data.pokerObj.tableId : data.tableId : data.joinedPoolID}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                            </div>
                            <div className='ts-id'>
                                <span>Tourney Name: </span>
                                {/* <span className='ts-id-value'>{data.gameType === 'poker' ? data.tableName : (data.joinedPoolName) ? data.joinedPoolName : data.joinedPoolType}</span> */}
                                <span className='ts-id-value'>{data.gameType === 'poker' ? data.pokerObj!==undefined ? data.pokerObj.tableName : data.tableName : (data.joinedPoolName) ? data.joinedPoolName : data.joinedPoolType}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                            </div>
                        </div>
                    )
                }
                break
            case 'Add Cash':
                middleSectionHTML = (
                    <div style={{ display: "flex", flexDirection: "column", backgroundColor: "" }}>
                        <div id='check' className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            {
                                data.eventType === 'TXN_FAILURE' || data.eventType === 'PENDING' ?
                                    <>

                                        <div className='ts-id' style={{ width: "80%" }}>
                                            <span>Payment Mode: </span>
                                            <span className='ts-id-value'>{data.TransactionObject.mode}</span>
                                        </div>
                                        <div className='ts-payment-mode'>
                                            <span>Txn ID: </span>
                                            <span className='ts-bold-value'>{data.TransactionObject.order_id}</span>
                                        </div>

                                    </>
                                    :
                                    <>

                                        <div className='ts-id' style={{ width: "80%", backgroundColor: "" }}>
                                            <span>Payment Mode: </span>
                                            <span className='ts-id-value'>{data.paymentMode}</span>
                                        </div>

                                        <div className='ts-payment-mode'>
                                            <span>Txn ID: </span>
                                            <span className='ts-bold-value'>{data.transactionID}</span>
                                        </div>

                                    </>
                            }



                        </div>

                        {/* {console.log("dfvndfgjbhdfgjbhdfgjhbdfghjbdf",data.amount)} */}
                        {(data && data.gstAmount) ? <div style={{ width: "100%", backgroundColor: "" }}>
                            {/* <div className='ts-more-info-row1' style={{ marginTop: "5px", marginBottom: "5px" }} >
                                <span>Deposit : </span>
                                <span className='ts-bold-value'>&#8377; {data.amount} </span>
                            </div> */}

                            <div className='ts-more-info-row1' style={{ marginTop: "5px", marginBottom: "5px" }} >
                                <span id='gst-charges-row-title'>GST : </span>
                                <span id='gst-changes-row-amount' className='ts-bold-value-red' style={{  }}> {Number(data.gstAmount) > 0 ? <span className='ts-bold-value'>+ &#8377;{data.gstAmount}</span> : <span>&#8377; 0</span>} </span>
                            </div>

                            <div id='total-amount-paid-total-div' className='total-amount-paid-total-div' >
                                {/* className='ts-more-info-row1' */}
                                <span style={{ marginLeft: "5px" }}>Total amount paid : </span>
                                <span className='ts-bold-value' style={{ marginRight: "5px" }}>&#8377;{data.purchaseAmount > 0 ? data.purchaseAmount : ""} </span>
                            </div>

                            <div className='ts-more-info-row2' style={{ backgroundColor: "", height: "25px" }}>
                            </div>
                            {/* <span className='ts-bold-value'>{data.TransactionObject.order_id}</span> */}
                        </div> : ""}
                    </div>


                )
                break
            case 'TDSApplied':
                if (data.eventType === 'yearEndTDS') {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>Transaction ID: </span>
                                <span className='ts-bold-value'>{data?.transactionID ? data.transactionID : 'NA' }</span>
                            </div>
                        </div>
                    )
                }
                // middleSectionHTML = (
                //     <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                //         <div className='ts-payment-mode'>
                //             <span>Transaction ID: </span>
                //             <span className='ts-bold-value'>{data?.transactionID ? data?.transactionID : 'NA' }</span>
                //         </div>
                //     </div>
                // )
                break
            case 'Withdrawal':
                if(data.eventType==='smartRedeemWallet' || data.eventType==='bonus-extraCash-smartRedeem'){
                    middleSectionHTML=(
                        <div className={(data?.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-id'>
                                <span>Transaction ID: </span>
                                <span className='ts-id-value'>{data?.transactionID ? data?.transactionID : 'NA'}</span>
                            </div>
                        </div>
                    )
                }
                else{
                    middleSectionHTML = (
                        <>
                            <div className='ts-more-info-row ts-no-border'>
                                <div className='ts-payment-mode'>
                                    <span>Transaction ID: </span>
                                    <span className='ts-bold-value'>{((data.eventStatus === 'Success' || data.eventType === 'withdraw-processing') && (data.TransactionObject)) ? data.TransactionObject.transactionReference : data.transactionReference}</span>
                                </div>
                                <div className='ts-id'>
                                    <span>Payment Mode: </span>
                                    <span className='ts-id-value'>{((data.eventStatus === 'Success' || data.eventType === 'withdraw-processing') && (data.TransactionObject)) ? data.TransactionObject?.withdrawType : data.withdrawType}</span>
                                </div>
                            </div>
                            {data.eventType!=='withdraw-cancelled-partial' &&<div className='ts-more-info-row ts-no-border'>
                                <div className='ts-payment-mode'>
                                    <span>TDS Deducted: </span>
                                    <span className='ts-bold-value'>{((data.eventStatus === 'Success' || data.eventType === 'withdraw-processing') && (data.TransactionObject)) ? data.TransactionObject?.tdsAmount : data.tdsAmount}</span>
                                </div>
                                {/* {console.log("Number >>>>>>>>>>>>>>",data.TransactionObject)} */}
                                <div className='ts-id'>
                                    <span>Total Amount Credited: </span>
                                    {
                                        (data.eventStatus === 'Pending' || data.eventStatus === 'Failed' || data.eventStatus === 'Cancelled' || data.event === 'TDSApplied' || data.eventStatus === 'Partially Cancelled') ?
                                            <span className='ts-id-value'>NA</span>
                                            :
                                            <span className='ts-id-value'>{(data.eventStatus === 'Success' || data.eventType === 'withdraw-processing') ? (data.TransactionObject) ? Math.abs(data.TransactionObject?.newRedeemAmount.toFixed(2)) : Math.abs(data?.newRedeemAmount.toFixed(2)) : Math.abs(data?.newRedeemAmount.toFixed(2))}</span>
                                        // <span className='ts-id-value'>{(data.eventStatus === 'Success' || data.eventType === 'withdraw-processing') ? Math.abs(data.TransactionObject?.newRedeemAmount.toFixed(2)) : Math.abs(data.newRedeemAmount.toFixed(2))}</span>
                                    }
                                </div>
                            </div>}
                            {(data?.transactionType==='paidInstant' && data?.processingFeeAmtTxnSummary>0) && 
                            <div className={'ts-more-info-row ts-no-border'} >
                                <div className='ts-id'>
                                        <span>Processing Fees: </span>
                                        <span className='ts-id-value'>{RUPEE_SYMBOL}{data.processingFeeAmtTxnSummary}</span>
                                    </div>
                            </div>
                            }
                            <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                                {data.eventType !== 'withdraw-cancelled-partial' &&
                                    <>
                                    <div className='ts-payment-mode'>
                                        <span>Requested Time: </span>
                                        <span className='ts-bold-value'>{new Date(data.createdAt).toLocaleDateString('en-GB') + ', ' + new Date(data.createdAt).toLocaleTimeString()}</span>
                                    </div>
                                    {(data.eventType !== 'withdraw-cancelled' && data?.partialRedeemCancellationCount > 0 && (data?.amountCancelled && data?.amountCancelled!==null && data?.amountCancelled!=='')) && 
                                        <div className='ts-id'>
                                        <span>Cancelled Amount: </span>
                                        <span className='ts-id-value'>&#8377;{(data?.amountCancelled && data?.amountCancelled!==null && data?.amountCancelled!=='') && Math.abs(Number(data?.amountCancelled))}</span>
                                    </div>
                                    }
                                    </>
                                    
                                }
                                {
                                    (data.eventType === 'withdraw-cancelled' || data.eventType === 'withdraw-cancelled-partial') &&
                                    <div className='ts-id'>
                                        <span>Cancelled Time: </span>
                                        <span className='ts-id-value'>{new Date(data.updatedAt).toLocaleDateString('en-GB') + ', ' + new Date(data.updatedAt).toLocaleTimeString()}</span>
                                    </div>
                                }
                            </div>
                            
                        </>
                    )
                }
                break
            case 'Acepoint':
                if (data.eventType === 'ace-tourney-reg' || data.eventType === 'ace-tourney-unreg') {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>Tourney ID: </span>
                                <span className='ts-bold-value'>{data.joinedPoolID}</span>
                            </div>
                            <div className='ts-id'>
                                <span>Tourney Name: </span>
                                <span className='ts-id-value'>{data.joinedPoolName}</span>
                            </div>
                        </div>
                    )
                }
                break
            case 'Tourney':
                if (data.type === 'locked-winnings-released') {
                    middleSectionHTML = null
                } else {
                    middleSectionHTML = (
                        <>
                           {(data.description && (data?.a23TDSLiability > 0 || !data.playerTDSLiability) ) ? <div className={(data.description && !(data?.a23TDSLiability!==null && data?.a23TDSLiability!==undefined && data?.a23TDSLiability!=='')) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                                {console.log("data.gameType", data.gameType)}
                                <div className='ts-payment-mode'>
                                    <span id="tdid">Tourney ID: </span>
                                    {/* <span className='ts-bold-value'>{data.gameType === 'poker' ? data.tableId : data.gameType === 'callbreak-tourney' ? data.tourney_id : data.joinedPoolID}</span> */}
                                    <span className='ts-bold-value'>{data.gameType === 'poker' ? data.pokerObj !== undefined ? data.pokerObj.tableId : data.tableId : data.gameType === 'callbreak-tourney' ? data.tourney_id : data.joinedPoolID}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                                </div>
                                <div className='ts-id'>
                                    <span>Tourney Name: </span>
                                    {/* <span className='ts-id-value'>{data.gameType === 'poker' ? data.tableName : data.gameType === 'callbreak-tourney' ? data.tourneyName : (data.joinedPoolName) ? data.joinedPoolName : data.joinedPoolType}</span> */}
                                    <span className='ts-id-value'>{data.gameType === 'poker' ? data.pokerObj !== undefined ? data.pokerObj.tableName : data.tableName : data.gameType === 'callbreak-tourney' ? data.tourneyName : (data.joinedPoolName) ? data.joinedPoolName : data.joinedPoolType}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                                </div>
                            </div> : 
                            
                           (data.description && (data?.a23TDSLiability <= 0 || !data.a23TDSLiability)&& data.playerTDSLiability > 0) ? <div className={(data.description && !(data?.playerTDSLiability!==null && data?.playerTDSLiability!==undefined && data?.playerTDSLiability!=='')) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                                {console.log("data.gameType", data.gameType)}
                                <div className='ts-payment-mode'>
                                    <span id="tdid">Tourney ID: </span>
                                    {/* <span className='ts-bold-value'>{data.gameType === 'poker' ? data.tableId : data.gameType === 'callbreak-tourney' ? data.tourney_id : data.joinedPoolID}</span> */}
                                    <span className='ts-bold-value'>{data.gameType === 'poker' ? data.pokerObj !== undefined ? data.pokerObj.tableId : data.tableId : data.gameType === 'callbreak-tourney' ? data.tourney_id : data.joinedPoolID}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                                </div>
                                <div className='ts-id'>
                                    <span>Tourney Name: </span>
                                    {/* <span className='ts-id-value'>{data.gameType === 'poker' ? data.tableName : data.gameType === 'callbreak-tourney' ? data.tourneyName : (data.joinedPoolName) ? data.joinedPoolName : data.joinedPoolType}</span> */}
                                    <span className='ts-id-value'>{data.gameType === 'poker' ? data.pokerObj !== undefined ? data.pokerObj.tableName : data.tableName : data.gameType === 'callbreak-tourney' ? data.tourneyName : (data.joinedPoolName) ? data.joinedPoolName : data.joinedPoolType}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                                </div>
                            </div>

                            :

                            <div className={'ts-more-info-row ts-no-border'}>
                                {console.log("data.gameType", data.gameType)}
                                <div className='ts-payment-mode'>
                                    <span id="tdid">Tourney ID: </span>
                                    {/* <span className='ts-bold-value'>{data.gameType === 'poker' ? data.tableId : data.gameType === 'callbreak-tourney' ? data.tourney_id : data.joinedPoolID}</span> */}
                                    <span className='ts-bold-value'>{data.gameType === 'poker' ? data.pokerObj !== undefined ? data.pokerObj.tableId : data.tableId : data.gameType === 'callbreak-tourney' ? data.tourney_id : data.joinedPoolID}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                                </div>
                                <div className='ts-id'>
                                    <span>Tourney Name: </span>
                                    {/* <span className='ts-id-value'>{data.gameType === 'poker' ? data.tableName : data.gameType === 'callbreak-tourney' ? data.tourneyName : (data.joinedPoolName) ? data.joinedPoolName : data.joinedPoolType}</span> */}
                                    <span className='ts-id-value'>{data.gameType === 'poker' ? data.pokerObj !== undefined ? data.pokerObj.tableName : data.tableName : data.gameType === 'callbreak-tourney' ? data.tourneyName : (data.joinedPoolName) ? data.joinedPoolName : data.joinedPoolType}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                                </div>
                            </div>
                            }


                            { (data?.a23TDSLiability > 0) ? (data?.a23TDSLiability!==null && data?.a23TDSLiability!==undefined && data?.a23TDSLiability!=='') && <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                                <div className='ts-payment-mode'>
                                    <span id="tdid">TDS Deducted: </span>
                                    <span className='ts-bold-value'>{data?.a23TDSLiability}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                                </div>
                            </div> 
                            :
                            (data?.a23TDSLiability <= 0 && data.playerTDSLiability > 0 ) ?(data?.playerTDSLiability!==null && data?.playerTDSLiability!==undefined && data?.playerTDSLiability!=='') && <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                                <div className='ts-payment-mode'>
                                    <span id="tdid">TDS Deducted: </span>
                                    <span className='ts-bold-value'>{data?.playerTDSLiability}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                                </div>
                            </div>

                            :
                            ""

                            //  <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            //     <div className='ts-payment-mode'>
                            //         <span id="tdid">TDS Deducted: </span>
                            //         <span className='ts-bold-value'>{0}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                            //     </div>
                            // </div>
                            }
                        </>
                    )
                }
                break
            case 'Leaderboard':
                if (data.eventType === 'lb-convenience-fee') {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>GameID: </span>
                                <span className='ts-bold-value'>{data.gameId}</span>
                            </div>
                            <div className='ts-id'>
                                <span>LBID: </span>
                                <span className='ts-id-value'>{data.lbId}</span>
                            </div>
                        </div>
                    )
                }
                else {
                    middleSectionHTML = (
                        <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                            <div className='ts-payment-mode'>
                                <span>Lb Id: </span>
                                <span className='ts-bold-value'>{data.lbId}</span>
                            </div>
                            <div className='ts-id'>
                                <span>Lb Name: </span>
                                <span className='ts-id-value'>{data.lbName}</span>
                            </div>
                        </div>
                    )
                }
                break
            case 'Game':
                if (data.appType === 'fantasy' && data.eventType !== 'Won') {
                    middleSectionHTML = (
                        <>
                            {/* First Fantasy Row */}
                            <div className='ts-more-info-fantasy-row ts-no-border'>
                                <div className='ts-payment-mode'>
                                    <span className='ts-bold-value'>{data.joinedPoolName}</span>
                                </div>
                                {
                                    (data.joinedPoolType === 'cricket' && data.inningsType) ?
                                        <div className='ts-payment-mode'>
                                            {
                                                data.inningsType === 'fullMatch'
                                                    ?
                                                    <span className='ts-bold-value'>{'T' + data.joinedTeamName.split(' ')[1] + ' ' + data.joinedTeamName.split(' ')[2] + ' ' + '(' + data.inningsType + ')'}</span>
                                                    :
                                                    <span className='ts-bold-value'>{'S-T' + data.joinedTeamName.split(' ')[1] + ' ' + data.joinedTeamName.split(' ')[2] + ' ' + '(' + data.inningsType + ')'}</span>

                                            }
                                        </div>
                                        :
                                        <div className='ts-payment-mode'>
                                            <span className='ts-bold-value'>{'T' + data.joinedTeamName.split(' ')[1] + ' ' + data.joinedTeamName.split(' ')[2]}</span>
                                        </div>
                                }
                            </div>
                            {/* Second Fantasy Row */}
                            <div className='ts-more-info-fantasy-row'>
                                <div className='ts-payment-mode'>
                                    <span className=''>{data.joinedMatchVsDetails}</span>
                                </div>
                                {
                                    // (data.joinedPoolType === 'cricket' && data.inningsType) ?
                                    <div className='ts-payment-mode'>
                                        <span className=''>{data.matchCompetitionName}</span>
                                    </div>
                                }
                            </div>

                            {
                                // This is the money break down which should not be shwon for Suspend
                                (data.eventType !== 'Suspend' && data.eventType !== 'pool-suspend')
                                    ?
                                    <>
                                        <div className='ts-more-info-fantasy-row ts-no-border'>
                                            <div className='ts-payment-mode'>
                                                <span style={{ color: '#032146' }}>Discount Applied:</span>
                                            </div>
                                            <div className='ts-payment-mode'>
                                                <span className='ts-bold-value' style={{ color: '#032146' }}>{Math.abs(data.discount)}</span>
                                            </div>
                                        </div>
                                        <div className='ts-more-info-fantasy-row ts-no-border'>
                                            <div className='ts-payment-mode'>
                                                <span className='' style={{ color: '#032146' }}>Withdrawable:</span>
                                            </div>
                                            <div className='ts-payment-mode'>
                                                <span className='ts-bold-value' style={{ color: '#032146' }}>{Math.abs(data.d + data.w).toFixed(2)}</span>
                                            </div>
                                        </div>
                                        <div className='ts-more-info-fantasy-row blue-row'>
                                            <div className='ts-payment-mode'>
                                                <span className='' style={{ color: '#032146' }}>Bonus Cash:</span>
                                            </div>
                                            <div className='ts-payment-mode'>
                                                <span className='ts-bold-value' style={{ color: '#032146' }}>{Math.abs(data.b + data.e)}</span>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    null
                            }
                        </>
                    )
                }else if (data.appType === 'ludo' && (data.eventType === 'debit-ludo' || data.eventType === 'refund')) {
                    console.log(data)
                    middleSectionHTML = (
                        <>
                            <div className='ts-more-info-row ts-no-border'>
                                <div className='ts-payment-mode'>
                                    <span>Game ID: </span>
                                    <span className='ts-bold-value'>{data.gameID}</span>
                                </div>
                            </div>
                            <div className='ts-more-info-fantasy-row'>
                                <div className='ts-payment-mode'>
                                    <span className='' style={{ color: '#032146' }}>Redeemable:</span>
                                </div>
                                <div className='ts-payment-mode'>
                                    <span className='ts-bold-value' style={{ color: '#032146' }}>{Math.abs(data.t_atTable + data.w_atTable).toFixed(2)}</span>
                                </div>
                            </div>
                            <div className='ts-more-info-fantasy-row blue-row'>
                                <div className='ts-payment-mode'>
                                    <span className='' style={{ color: '#032146' }}>Bonus Cash:</span>
                                </div>
                                <div className='ts-payment-mode'>
                                    <span className='ts-bold-value' style={{ color: '#032146' }}>{Math.abs(data.b_atTable + data.e_atTable)}</span>
                                </div>
                            </div>
                        </>
                    )
                } else if (data.eventType === 'game entry after applying discount') {
                    middleSectionHTML = (
                        <>
                            <div className='ts-more-info-row ts-no-border'>
                                <div className='ts-payment-mode'>
                                    <span>Discount Voucher Applied: </span>
                                    <span className='ts-bold-value'>{data.transactionID}</span>
                                </div>
                                <div className='ts-id'>
                                    <span>Voucher Code: </span>
                                    <span className='ts-id-value'>{data.paymentMode}</span>
                                </div>
                            </div>
                            <div className={(data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                                <div className='ts-payment-mode'>
                                    <span >Game ID: </span>
                                    <span className='ts-bold-value'>{data.transactionID}</span>
                                </div>
                            </div>
                        </>
                    )
                } else if (data.eventType === 'PointsRummy') {
                    middleSectionHTML = (
                        <>
                            <div className={(data.description && !(data.gamePassId && data.gamePassId!=='' && data.type.toLowerCase() !== "won")) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                                <div className='ts-payment-mode'>
                                    <span >Game ID: </span>
                                    <span className='ts-bold-value'>{data.gameId}</span>
                                </div>
                                
                            </div>
                            { (data.gamePassId && data.gamePassId!=='' && data.type.toLowerCase() !== "won") &&
                                    <div className={(data.description && data.gamePassId) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'} style={{justifyContent:"start"}}>

                                        <span>Wallet - <span style={{ fontWeight: "700" }}>&#8377;{Math.abs(Number(data.userWalletAmount))}</span></span>
                                        <div className='date-time-divider'> </div>
                                        <span> PlayPass - <span style={{ fontWeight: "700" }}>&#8377;{data?.gamePassAmount}</span></span>
                                    </div>
                                }

                        </>
                    )
                } else if (data.eventType === 'GunShot'){
                    middleSectionHTML = (
                        <div className='ts-more-info-column'>
                            {
                                data.gamesDetails.map((item, index) => {
                                    return (
                                        <div className='ts-single-game-row' key={item + index + Math.random()}>
                                            <div className='ts-single-game'>
                                                <span>{new Date(item.createdAt).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}</span>
                                                <span style={{ margin: '0rem 0.25rem' }}>|</span>
                                                <span style={{ marginRight: '0.25rem' }}>Game ID :</span>
                                                <span className='ts-bold-value'>{item.status.split(' - ')[0]}</span>
                                                <span style={{ margin: '0rem 0.25rem' }}>-</span>
                                                <span className=''>{item.type}</span>
                                            </div>
                                            <div className='ts-single-game'>
                                                <img style={{ width: '15px', height: '15px' }} src={item.type.toLowerCase() === 'won' ? assets?.assets?.claimed : assets?.assets?.paid}></img>
                                                <span className='ts-bold-value'>&#8377;{Math.abs(Number(item.amount).toFixed(2))}</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )
                }
                
                else {
                    middleSectionHTML = (
                        <>

                            {data?.gamePassId ? <div style={{ width: "100%", height: "60px", backgroundColor: "", padding: "10px 0px", display: "flex", flexDirection: "column", borderBottom: "1px solid #BABABA" }}>
                                <div style={{ width: "100%", height: "50%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                                    <div id='gameIDDiv' style={{ width: "40%", backgroundColor: "", display: "flex", gap: "5px" }}>
                                        <span> {data.gameType === 'poker' ? 'Table Name: ' : data.appType === 'fantasy' ? null : 'Game ID: '}</span>
                                        {/* <span className='ts-bold-value'>{data.gameType === 'poker' ? data.tableName : (data.appType === 'fantasy') ? data.joinedMatchDetails : data.gameID}</span> */}
                                        <span className='ts-bold-value'>{data.gameType === 'poker' ? data.pokerObj!==undefined ? data.pokerObj.tableName : data.tableName : (data.appType === 'fantasy') ? data.joinedMatchDetails : data.gameID}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}

                                    </div>

                                    <div id="nee" style={{ width: "60%", backgroundColor: "", display: "flex", gap: "5px", justifyContent: "flex-end" }}>
                                        {/* <span>{dateFormatter(data.createdAt)}</span> */}
                                        {console.log("Wallet amount >>>>>>>>>>>", data.amount)}

                                        {/* <span>{timeFormatter(data.createdAt)}</span> */}

                                    </div>


                                </div>
                                {console.log("data.type",data.type)}
                               {data.type && data.type.toLowerCase() === "won" ? <div id="gamePassId" style={{ width: "100%", height: "50%", backgroundColor: "", display: "flex", alignItems: "center", gap: "5px",marginTop:"2%"}}>
                                    {/* <span style={{}}>Game Pass ID :</span>
        
                                   <span style={{}}>{ data?.gamePassId}</span> */}
                                   
                                   {data.gamePassWinnings ?   <span>Winnings +<span style={{ fontWeight: "600px" }}>&#8377;{Math.abs(Number(data.gamePassWinnings))}</span> </span>: <span>Winnings - <span style={{ fontWeight: "600px" }}>NA</span> </span> }
                                    <div className='date-time-divider' style={{ height: "100%" }}> </div>
                                   {data.gamePassBonusCash ? <span> Bonus Cash + <span style={{ fontWeight: "600px" }}>&#8377;{data.gamePassBonusCash}</span></span>:<span> Bonus Cash - <span style={{ fontWeight: "600px" }}>NA</span></span>}
                                </div> :
                                  data.type && data.type.toLowerCase().search("leavetable") >= 0 ? 
                                  <div id="gamePassId" style={{ width: "100%", height: "50%", backgroundColor: "", display: "flex", alignItems: "center", gap: "5px",marginTop:"2%"}}>
                                    {/* <span style={{}}>Game Pass ID :</span>
        
                                   <span style={{}}>{ data?.gamePassId}</span> */}
                                   
                                    <span>Wallet  +<span style={{ fontWeight: "600px" }}>&#8377;{Math.abs(Number(data.amount))}</span></span>
                                    <div className='date-time-divider' style={{ height: "100%" }}> </div>
                                    <span> PlayPass +<span style={{ fontWeight: "600px" }}>&#8377;{data?.gamePassAmount}</span></span>
                                </div>
                                   : <div id="gamePassId" style={{ width: "100%", height: "50%", backgroundColor: "", display: "flex", alignItems: "center", gap: "5px",marginTop:"2%"}}>
                                    {/* <span style={{}}>Game Pass ID :</span>
        
                                   <span style={{}}>{ data?.gamePassId}</span> */}
                                   
                                    <span>Wallet - <span style={{ fontWeight: "600px" }}>&#8377;{Math.abs(Number(data.amount))}</span></span>
                                    <div className='date-time-divider' style={{ height: "100%" }}> </div>
                                    <span> PlayPass - <span style={{ fontWeight: "600px" }}>&#8377;{data?.gamePassAmount}</span></span>
                                </div> }

                            </div> : <div className={(data.eventType === 'Won' && data.appType === 'fantasy') ? 'ts-more-info-row' : (data.description) ? 'ts-more-info-row' : 'ts-more-info-row ts-no-border'}>
                                {console.log("hbdhjbdj", data)}

                                {
                                    <div className='ts-payment-mode' >
                                        <span id="eeee">{data.gameType === 'poker' ? 'Table Name: ' : data.appType === 'fantasy' ? null : 'Game ID: '} </span>
                                        {/* <span className='ts-bold-value'>{data.gameType === 'poker' ? data.tableName : (data.appType === 'fantasy') ? data.joinedMatchDetails : data.gameID}</span> */}
                                        <span className='ts-bold-value'>{data.gameType === 'poker' ? data.pokerObj!==undefined ? data.pokerObj.tableName : data.tableName  : (data.appType === 'fantasy') ? data.joinedMatchDetails : data.gameID}</span> {/** If pokerObj is available, Record belongs to digient poker else its IPMAN record*/}
                                    </div>
                                }


                                {
                                    (data.voucherCode)
                                        ?
                                        <div className='ts-payment-mode'>
                                            <span className=''>Voucher Code: </span>
                                            <span className='ts-bold-value'>{data.voucherCode}</span>
                                        </div>
                                        :
                                        null
                                }
                                {
                                    data.appType === 'fantasy' ?
                                        <div className='ts-id'>
                                            {/* <span>Contest Name: </span> */}
                                            <span className='ts-bold-value'>{data.joinedPoolName}</span>
                                        </div>
                                        :
                                        null
                                }
                            </div>}
                        </>
                    )
                }
                break
        }
        return middleSectionHTML
    }

    const handleItemExpand = () => {
        if (data.description || middleSectionDisplay(data) !== null) {
            // setExpand(!expand)
            console.log(index)
            if (expand) {
                setExpandedIndex(null)
            } else {
                setExpandedIndex(index)
            }
        }
        return
    }

    return (
        <div className='ts-item' onClick={(e) => handleItemExpand(e)}>
            <div className='ts-item-header'>
                <div className='ts-item-details'>
                    <div className='ts-details-top'>
                        <div className='ts-item-name'>
                            {/* <span id='transaction-status-name'>{data.TransactionStatus}</span> */}
                            <span id={data.TransactionStatus}>{data.TransactionStatus.replace("Smart Redeem", "Wallet Booster")}</span>
                        </div>
                        <div className='ts-item-amount'>
                            <img style={{ width: '20px', marginRight: '10px' }}
                                src={
                                    data.eventStatus === 'Claimed' || data.eventStatus === 'Success' ?
                                        (data.eventType==='smartRedeemWallet' || data.eventType==='bonus-extraCash-smartRedeem') ? SmartToWalletSuccess : (data.eventType==='withdraw-request' && data?.smartRedeem===true) ? SmartToBankSuccess : assets?.assets?.claimed :
                                        data.eventStatus === 'Paid' ?
                                            assets?.assets?.paid :
                                            data.eventStatus === 'Cancelled' ?
                                                assets?.assets?.cancelled :
                                                (data.eventStatus === 'Failed') ?
                                                assets?.assets?.failed :
                                                    data.eventStatus === 'Reject' ?
                                                    assets?.assets?.rejectIcon :
                                                    data.eventStatus === 'Partially Cancelled' ? 
                                                    assets?.assets?.partialCancelIcon :
                                                    data.eventStatus === "refunded" ?  assets?.assets?.bankIcon1:
                                                    assets?.assets?.pending
                                }>
                            </img>

                            {console.log(" is gems are true >>>>",data.gems)}
                            {
                                // data.event === 'Acepoint' ?
                                //     <span>AP {
                                //         data.amount ?
                                //             Math.abs(Number(data.amount)).toFixed(2)
                                //             :
                                //             0
                                //     }
                                //     </span>
                                //     :
                                
                                (data.event === 'Leaderboard' && data.type === 'lb_winner') ?
                                    <span color={'#00BA4D'}>{data.lbPrize.length > 12 ? data.lbPrize.slice(0, 12) + `...` : data.lbPrize}</span>
                                    :
                                    <span id='transaction-record-amount'>  {(data.eventType === 'ace-tourney-reg' || data.eventType === 'ace-tourney-unreg')? <span></span>:<span>&#8377;</span>}{
                                        data.event && data.event === 'Add Cash' ?
                                            data.purchaseAmount ? Math.abs(Number(data.purchaseAmount)).toFixed(2) : data.amount ? Math.abs(Number(data.amount)).toFixed(2) : 0
                                            :
                                            // "nbnnn"(data.eventType === 'ace-tourney-reg' || data.eventType === 'ace-tourney-unreg')?
                                            (data.eventType === 'ace-tourney-reg' || data.eventType === 'ace-tourney-unreg')? data.betAmount ? data.betAmount + " AP" : 0 : data.amount ? Math.abs(Number(data.amount)).toFixed(2) : 0
                                    } 
                                    
                                    </span>

                                    
                            }
                            {data.gems ? <img style={{width:"20px",height:"20px",marginLeft:"5px"}} src={GemIcon}></img> :""}
                        </div>
                    </div>
                    <div className='ts-details-bottom'>
                        <div className='ts-item-date-time'>
                            <span>{dateFormatter(data.createdAt)}</span>
                            <div className='date-time-divider'>
                                {/* DIVIDER */}
                            </div>
                            <span>{timeFormatter(data.createdAt)}</span>
                        </div>
                        <div className='ts-item-type'>
                            <span>{data.eventStatus}</span>
                        </div>
                    </div>
                </div>

                {
                    // If there is a description or middle section is not equal to null, show expand button
                    (data.description || middleSectionDisplay(data) !== null) &&
                    <div className='ts-item-expand'>
                        <img style={{ width: '12px', transform: (expand) ? 'rotate(180deg)' : null, zIndex: 1 }} src={downarrow}></img>
                    </div>
                }
            </div>

            {
                (data.eventType === 'ace-tourney-reg' || data.eventType === 'ace-tourney-unreg'  || data.appType === 'fantasy'|| data.eventType === 'rne-referrer-bonus') ?
               (data.appType === 'fantasy'|| data.eventType === 'rne-referrer-bonus') ?  null : (data.acePointBalance) ?  <div className='ts-description-tb'>
                {
                    <span>Ace Points Balance: {(data.acePointBalance)} AP</span>
                      
                }
            </div>:null
                    :
                    (data.eventStatus === 'Pending' || data.eventStatus === 'Failed') ?
                        <div className='ts-description-tb'>
                            <span>Wallet Balance: Not Available</span>
                        </div>
                        :
                        (data.totalBalance) ?
                            <div className='ts-description-tb'>
                                {
                                    data.totalBalance === '--'
                                        ?
                                        <span>Wallet Balance: --</span>
                                        :
                                        <span>Wallet Balance: &#8377;{Number(data.totalBalance).toFixed(2)}</span>
                                }
                            </div>
                            :

                           null
            }
            <>
                {
                    expand &&
                    <div className='ts-item-more-info'>
                        {middleSectionDisplay(data)}
                        {data.eventType === 'rne-referrer-bonus' &&
                            <div className='ts-more-info-bottom' >
                                <div style={{display:'flex',justifyContent:'space-around'}}>
                                    {/* <div style={{width:'25%',borderRight:'1px solid #bababa',display:'flex',justifyContent:'space-around',flexDirection:'column',alignItems:'center',padding:"7px 0px"}}>
                                        <span style={{marginBottom:"3px"}}>Deposits</span>
                                        <span style={{fontSize:"0.9rem",fontWeight:"700"}}> &#8377; {Number(data.tnx).toFixed(2)}</span>
                                    </div> */}
                                    <div style={{width:'25%',borderRight:'1px solid #bababa',display:'flex',justifyContent:'space-around',flexDirection:'column',alignItems:'center',padding:"7px 0px"}}>
                                        
                                        <span style={{marginBottom:"3px",position:"relative"}}>
                                        <div style={{width:"6px",height:'6px',background:"green",borderRadius:'50%',position:'absolute',top:"-5px",right:'-10px'}}></div>
                                            Bonus Cash
                                        </span>
                                        <span style={{fontSize:"0.9rem",fontWeight:"700"}}> &#8377; {Number(data.extraCash).toFixed(2)}</span>
                                    </div>
                                    <div style={{width:'25%',borderRight:'1px solid #bababa',display:'flex',justifyContent:'space-around',flexDirection:'column',alignItems:'center',padding:"7px 0px"}}>
                                        <span style={{marginBottom:"3px"}}>Winnings</span>
                                        <span style={{fontSize:"0.9rem",fontWeight:"700"}}> &#8377; {Number(data.win).toFixed(2)}</span>
                                    </div>
                                    <div style={{width:'25%',display:'flex',justifyContent:'space-around',flexDirection:'column',alignItems:'center'}}>
                                        <div style={{width:'90%',padding:"7px 0px",background:!isOem?'rgb(175,192,221)':"#59462E",display:'flex',justifyContent:'space-around',flexDirection:'column',alignItems:'center',borderRadius:"3px"}}>
                                        <span style={{marginBottom:"3px"}}>Wallet Balance</span>
                                        <span style={{fontSize:"0.9rem",fontWeight:"700"}}> &#8377; {Number(data.totalBalance).toFixed(2)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        }

                        {
                            //   console.log("data >>>>>>>>>>>>",data.type)&&
                            data.eventType !== 'rne-referrer-bonus' && data.description &&
                            <div className={data.type === "AddCash" ? 'ts-more-info-bottom1' : 'ts-more-info-bottom'}>
                                {(data.invoiceUrl) ? <div className='ts-description-text' style={{ display: "flex" }}>

                                    {/* <span style={{width:"80%"}}>Description: {data.description}</span> */}
                                    <span style={{ width: "80%" }}>The GST invoice for the purchase is available for download now</span>
                                    <div style={{ width: "20%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                        <img src={InvoiceIcon} id='gst-invoice-download-icon' onClick={() => {
                                            //  <a download={"Invoice"}  href={data.invoiceUrl}/> //  sendMessageToNative({ downloadUrl: filelink })
                                            WebToNativeMessage({ downloadUrl: data.invoiceUrl })
                                        }}></img>
                                    </div>

                                </div>
                                    :
                                    <div className='ts-description-text' style={{}}>

                                        <span id="description">Description: {data.description} {' '}   
                                        {(data.event==='TDSApplied' && data.eventType==='yearEndTDS') ? <span style={{textDecoration:"underline"}} onClick={(e)=>{
                                            setShowTDSIframe(true)
                                            e.stopPropagation()
                                            }}>Know More</span> : ''}</span>
                                    </div>}
                            </div>
                        }
                            {(data.event === 'Withdrawal' && (data.eventStatus === 'Success' || data.eventType === 'withdraw-request' || data.eventType==='withdraw-cancelled') && data?.partialRedeemCancellationCount > 0 && data?.partiallyCancelledArray) &&
                                (data?.partiallyCancelledArray.map((item) => {
                                    return (
                                        <>
                                            <div className='ts-more-info-row ts-no-border'>
                                                <div className='ts-payment-mode'>
                                                    <span>Redeem Partially Cancelled :</span>
                                                    <span className='ts-bold-value'>&#8377;{item?.amountCancelled ? Math.abs(Number(item?.amountCancelled)) : 'NA'} Cancelled</span>
                                                </div>
                                                <div>{new Date(item.createdAt).toLocaleDateString('en-GB') + ', ' + new Date(item.createdAt).toLocaleTimeString()}</div>
                                            </div>
                                        </>
                                    )
                                }))

                            }
                        {
                            (data.eventType !== 'rne-referrer-bonus' && (data.eventType === 'Suspend' || data.eventType === 'pool-suspend')) ?
                                <div className='ts-more-info-bottom'>
                                    <div className='ts-description-text'>
                                        <span style={{ color: '#F0745C' }}>Note: Incase of Discount Voucher used, discount amount will be available to reuse.</span>
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                }
            </>
        </div>
    )
}

{/* <div className='ts-more-wallet-info'>
<div className='ts-grid-item ts-deposits'>
<span className='ts-grid-item-title'>Deposits</span>
<span className='ts-grid-item-value'>&#8377;1000</span>
</div>
<div className='ts-grid-item ts-bonus-cash'>
<span className='ts-grid-item-title'>Bonus Cash</span>
<span className='ts-grid-item-value'>&#8377;1000</span>
</div>
<div className='ts-grid-item ts-winnings'>
<span className='ts-grid-item-title'>Winnings</span>
<span className='ts-grid-item-value'>&#8377;1000</span>
</div>
<div className='ts-grid-item ts-total-balance'>
<span className='ts-grid-item-title'>Wallet Balance</span>
<span className='ts-grid-item-value'>&#8377;1000</span>
</div>
</div> */}

export default TransactionItem